<div class="tab-navigation-container content-wrapper">
  <div class="tab-navigation">
    <button
      *ngFor="let tab of tabs; let i = index; trackBy: trackByTabId"
      class="tab-button"
      [class.active]="activeTab === tab.value"
      [class.first-index]="i === 0 && activeTab === tab.value"
      (click)="selectTab(tab)"
    >
      {{ tab.label }}
    </button>
  </div>
</div>
